import { Fragment, createElement } from "react";

export function authenticatedContentBoundaryKey(principal) {
  const normalized = String(principal || "").trim();
  return normalized ? `account:${normalized.length}:${normalized}` : "anonymous";
}

/**
 * React preserves local state by tree position. Keying the complete routed
 * subtree by account principal makes an account transition a hard ownership
 * boundary while leaving same-account token refreshes mounted.
 */
export function AuthenticatedContentBoundary({ principal, children }) {
  return createElement(
    Fragment,
    { key: authenticatedContentBoundaryKey(principal) },
    children,
  );
}
